module.exports = __webpack_public_path__ + "static/img/IN-login-progrss.04de6e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/IN-login-progrss.png
// module id = HSDW
// module chunks = 0